/* tslint:disable */
/* eslint-disable */
/**
 * 所在確認アラート API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BadRequestResponse
 */
export interface BadRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof BadRequestResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface PutWhereaboutsCheckSettingRequest
 */
export interface PutWhereaboutsCheckSettingRequest {
    /**
     * 所在確認アラートを利用するか
     * @type {boolean}
     * @memberof PutWhereaboutsCheckSettingRequest
     */
    'enabled'?: boolean;
    /**
     * 保護者通知を利用するか
     * @type {boolean}
     * @memberof PutWhereaboutsCheckSettingRequest
     */
    'parentNotificationEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface WhereaboutsCheckResultResponse
 */
export interface WhereaboutsCheckResultResponse {
    /**
     * 所在確認NGの園児一覧
     * @type {Array<WhereaboutsCheckResultResponseCheckResultNGChildrenInner>}
     * @memberof WhereaboutsCheckResultResponse
     */
    'checkResultNGChildren': Array<WhereaboutsCheckResultResponseCheckResultNGChildrenInner>;
}
/**
 * 
 * @export
 * @interface WhereaboutsCheckResultResponseCheckResultNGChildrenInner
 */
export interface WhereaboutsCheckResultResponseCheckResultNGChildrenInner {
    /**
     * 園児ID
     * @type {number}
     * @memberof WhereaboutsCheckResultResponseCheckResultNGChildrenInner
     */
    'childId': number;
    /**
     * 園児名
     * @type {string}
     * @memberof WhereaboutsCheckResultResponseCheckResultNGChildrenInner
     */
    'childName': string;
}
/**
 * 
 * @export
 * @interface WhereaboutsCheckSettingResponse
 */
export interface WhereaboutsCheckSettingResponse {
    /**
     * 所在確認アラートを利用するか
     * @type {boolean}
     * @memberof WhereaboutsCheckSettingResponse
     */
    'enabled': boolean;
    /**
     * 保護者通知を利用するか
     * @type {boolean}
     * @memberof WhereaboutsCheckSettingResponse
     */
    'parentNotificationEnabled': boolean;
}
/**
 * 
 * @export
 * @interface WhereaboutsCheckStatusResponse
 */
export interface WhereaboutsCheckStatusResponse {
    /**
     * システム停止中かどうか
     * @type {boolean}
     * @memberof WhereaboutsCheckStatusResponse
     */
    'isOutage': boolean;
    /**
     * 保護者通知停止中かどうか
     * @type {boolean}
     * @memberof WhereaboutsCheckStatusResponse
     */
    'isOutageParentNotification': boolean;
    /**
     * 保護者通知配信可能上限を超えたかどうか
     * @type {boolean}
     * @memberof WhereaboutsCheckStatusResponse
     */
    'isDeliveryLimitExceeded': boolean;
    /**
     * ステータス
     * @type {string}
     * @memberof WhereaboutsCheckStatusResponse
     */
    'status': WhereaboutsCheckStatusResponseStatusEnum;
    /**
     * 最終更新時刻
     * @type {string}
     * @memberof WhereaboutsCheckStatusResponse
     */
    'lastUpdatedAt': string;
    /**
     * 最新バージョン
     * @type {number}
     * @memberof WhereaboutsCheckStatusResponse
     */
    'latestVersion': number;
    /**
     * 次回更新予定までの秒数。予定がない場合は0。
     * @type {number}
     * @memberof WhereaboutsCheckStatusResponse
     */
    'secondsUntilNextUpdate': number;
}

export const WhereaboutsCheckStatusResponseStatusEnum = {
    Available: 'available',
    InPreparation: 'inPreparation',
    EndedToday: 'endedToday'
} as const;

export type WhereaboutsCheckStatusResponseStatusEnum = typeof WhereaboutsCheckStatusResponseStatusEnum[keyof typeof WhereaboutsCheckStatusResponseStatusEnum];


/**
 * WhereaboutsCheckApi - axios parameter creator
 * @export
 */
export const WhereaboutsCheckApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 所在確認チェックの結果を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhereaboutsCheckResult: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/admin/whereabouts_check_results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 所在確認チェックのステータスを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhereaboutsCheckStatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/admin/whereabouts_check_statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhereaboutsCheckApi - functional programming interface
 * @export
 */
export const WhereaboutsCheckApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhereaboutsCheckApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 所在確認チェックの結果を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhereaboutsCheckResult(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhereaboutsCheckResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhereaboutsCheckResult(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WhereaboutsCheckApi.getWhereaboutsCheckResult']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary 所在確認チェックのステータスを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhereaboutsCheckStatus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhereaboutsCheckStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhereaboutsCheckStatus(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WhereaboutsCheckApi.getWhereaboutsCheckStatus']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * WhereaboutsCheckApi - factory interface
 * @export
 */
export const WhereaboutsCheckApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhereaboutsCheckApiFp(configuration)
    return {
        /**
         * 
         * @summary 所在確認チェックの結果を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhereaboutsCheckResult(options?: any): AxiosPromise<WhereaboutsCheckResultResponse> {
            return localVarFp.getWhereaboutsCheckResult(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 所在確認チェックのステータスを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhereaboutsCheckStatus(options?: any): AxiosPromise<WhereaboutsCheckStatusResponse> {
            return localVarFp.getWhereaboutsCheckStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhereaboutsCheckApi - object-oriented interface
 * @export
 * @class WhereaboutsCheckApi
 * @extends {BaseAPI}
 */
export class WhereaboutsCheckApi extends BaseAPI {
    /**
     * 
     * @summary 所在確認チェックの結果を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhereaboutsCheckApi
     */
    public getWhereaboutsCheckResult(options?: AxiosRequestConfig) {
        return WhereaboutsCheckApiFp(this.configuration).getWhereaboutsCheckResult(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 所在確認チェックのステータスを取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhereaboutsCheckApi
     */
    public getWhereaboutsCheckStatus(options?: AxiosRequestConfig) {
        return WhereaboutsCheckApiFp(this.configuration).getWhereaboutsCheckStatus(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WhereaboutsCheckSettingApi - axios parameter creator
 * @export
 */
export const WhereaboutsCheckSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 施設が所在確認アラートを利用可能・不可能を取得する
         * @summary 所在確認アラートの設定取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhereaboutsCheckSetting: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/admin/whereabouts_check_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * - 施設が所在確認アラートを利用設定を行う - putにするべきだが、codmonのルーティングの都合上putにはidが必須なためpostにしている 
         * @summary 所在確認アラートの設定の更新
         * @param {PutWhereaboutsCheckSettingRequest} [putWhereaboutsCheckSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putWhereaboutsCheckSetting: async (putWhereaboutsCheckSettingRequest?: PutWhereaboutsCheckSettingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/admin/whereabouts_check_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putWhereaboutsCheckSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhereaboutsCheckSettingApi - functional programming interface
 * @export
 */
export const WhereaboutsCheckSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhereaboutsCheckSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * 施設が所在確認アラートを利用可能・不可能を取得する
         * @summary 所在確認アラートの設定取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhereaboutsCheckSetting(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhereaboutsCheckSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhereaboutsCheckSetting(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WhereaboutsCheckSettingApi.getWhereaboutsCheckSetting']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * - 施設が所在確認アラートを利用設定を行う - putにするべきだが、codmonのルーティングの都合上putにはidが必須なためpostにしている 
         * @summary 所在確認アラートの設定の更新
         * @param {PutWhereaboutsCheckSettingRequest} [putWhereaboutsCheckSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putWhereaboutsCheckSetting(putWhereaboutsCheckSettingRequest?: PutWhereaboutsCheckSettingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhereaboutsCheckSettingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putWhereaboutsCheckSetting(putWhereaboutsCheckSettingRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WhereaboutsCheckSettingApi.putWhereaboutsCheckSetting']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * WhereaboutsCheckSettingApi - factory interface
 * @export
 */
export const WhereaboutsCheckSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhereaboutsCheckSettingApiFp(configuration)
    return {
        /**
         * 施設が所在確認アラートを利用可能・不可能を取得する
         * @summary 所在確認アラートの設定取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhereaboutsCheckSetting(options?: any): AxiosPromise<WhereaboutsCheckSettingResponse> {
            return localVarFp.getWhereaboutsCheckSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * - 施設が所在確認アラートを利用設定を行う - putにするべきだが、codmonのルーティングの都合上putにはidが必須なためpostにしている 
         * @summary 所在確認アラートの設定の更新
         * @param {PutWhereaboutsCheckSettingRequest} [putWhereaboutsCheckSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putWhereaboutsCheckSetting(putWhereaboutsCheckSettingRequest?: PutWhereaboutsCheckSettingRequest, options?: any): AxiosPromise<WhereaboutsCheckSettingResponse> {
            return localVarFp.putWhereaboutsCheckSetting(putWhereaboutsCheckSettingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhereaboutsCheckSettingApi - object-oriented interface
 * @export
 * @class WhereaboutsCheckSettingApi
 * @extends {BaseAPI}
 */
export class WhereaboutsCheckSettingApi extends BaseAPI {
    /**
     * 施設が所在確認アラートを利用可能・不可能を取得する
     * @summary 所在確認アラートの設定取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhereaboutsCheckSettingApi
     */
    public getWhereaboutsCheckSetting(options?: AxiosRequestConfig) {
        return WhereaboutsCheckSettingApiFp(this.configuration).getWhereaboutsCheckSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * - 施設が所在確認アラートを利用設定を行う - putにするべきだが、codmonのルーティングの都合上putにはidが必須なためpostにしている 
     * @summary 所在確認アラートの設定の更新
     * @param {PutWhereaboutsCheckSettingRequest} [putWhereaboutsCheckSettingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhereaboutsCheckSettingApi
     */
    public putWhereaboutsCheckSetting(putWhereaboutsCheckSettingRequest?: PutWhereaboutsCheckSettingRequest, options?: AxiosRequestConfig) {
        return WhereaboutsCheckSettingApiFp(this.configuration).putWhereaboutsCheckSetting(putWhereaboutsCheckSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



